import { Link } from 'react-router-dom';
import { getTopRatedComics } from '@/mocks/comics';

export default function RankingSection() {
  const topComics = getTopRatedComics().slice(0, 10);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              漫画排行榜
            </h2>
            <p className="text-sm text-foreground-500 mt-1">口碑最好的高分漫画</p>
          </div>
          <Link
            to="/category/shaonian"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          <div className="divide-y divide-background-100">
            {topComics.slice(0, 3).map((comic, index) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 p-4 md:p-5 hover:bg-background-50/80 transition-colors cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                  index === 0 ? 'bg-accent-500 text-background-50' :
                  index === 1 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-300 text-foreground-700'
                }`}>
                  {index + 1}
                </div>
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 排行榜第${index + 1}名`}
                  className="w-14 h-[75px] object-cover object-top rounded-lg flex-shrink-0"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 line-clamp-1">{comic.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author} · {comic.status}</p>
                  <div className="flex flex-wrap gap-1.5 mt-1.5">
                    {comic.tags?.slice(0, 3).map((tag) => (
                      <span key={tag} className="text-xs bg-background-100 text-foreground-500 px-1.5 py-0.5 rounded whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-400 text-sm"></i>
                    </div>
                    <span className="text-sm font-bold text-foreground-900">{comic.rating}</span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-1">共{comic.chapters}话</p>
                </div>
              </Link>
            ))}
          </div>

          <div className="p-4 md:p-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
              {topComics.slice(3).map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex items-center gap-3 p-3 rounded-xl hover:bg-background-100/70 transition-colors cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-400 w-6 text-center">{index + 4}</span>
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-10 h-[53px] object-cover object-top rounded-md flex-shrink-0"
                    loading="lazy"
                  />
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-800 line-clamp-1">{comic.title}</h3>
                    <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  </div>
                  <span className="text-sm font-bold text-primary-500 flex-shrink-0">{comic.rating}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}